import React, { FC } from 'react';
import styled from 'styled-components';
import { CalenderMeta } from 'api/timesheets/integration/event';
import { HeaderParams } from '../types';
import { Caption } from './component';

const Wrapper = styled.div`
  font-weight: var(--font-weight-bold);
  color: var(--grid-header-color);
  display: flex;
  gap: var(--spacing-02);
  align-items: center;
`;

const Required = styled.div`
  color: var(--red-60);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-caption-01);
  font-weight: var(--font-weight-normal);
`;

interface EventHeaderRendererProps extends HeaderParams {
  calenderMeta: CalenderMeta;
}

export const EventHeaderRenderer: FC<EventHeaderRendererProps> = ({
  calenderMeta,
}) => {
  return (
    <Wrapper>
      {calenderMeta.day}
      <Caption>{calenderMeta.date}</Caption>
    </Wrapper>
  );
};

export const MandatoryRenderer: FC<HeaderParams> = ({ displayName }) => {
  return (
    <Wrapper>
      <Required>*</Required>
      {displayName}
    </Wrapper>
  );
};
